/** @type {import('tailwindcss').Config} */
module.exports = {
  content: ["./index.html", "./src/**/*.{vue,js,ts,jsx,tsx}"],
  darkMode: "class",
  safelist: [
    "whitelisted",
    { pattern: /(bg|text|border)-(teal|red)-(100|500|900)/ },
  ],
  theme: {
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1025px",
      xl: "1280px",
      xl1: "1366px",
      xl2: "1460px",
      "2xl": "1536px",
      "3xl": "1760px",
      "4xl": "1920px",
      "5xl": "2560px",
    },
    fontFamily: {
      sans: ["SF Pro Display", "sans-serif"],
    },
    extend: {
      // fontSize: {
      //   xs: [".75rem", "16px"],
      //   sm: [".875rem", "20px"],
      //   base: ["1rem", "24px"],
      //   md: ["1.125rem", "26px"],
      //   lg: ["1.25rem", "28px"],
      //   xl: ["1.5rem", "32px"],
      // },
      zIndex: {
        98: "98",
        100: "100",
        150: "150",
        200: "200",
      },
      colors: {
        transparent: "transparent",
        current: "currentColor",
        white: "#ffffff",
        black: "#000000",
        cursor: "#CDC3C35A",
        grey: "#9CA3AF",
        "dark-grey": "#6b6b6b",
        "dark-grey-alt": "#3a3a3a",
        "op-white": {
          40: "rgba(255, 255, 255, 0.04)",
          60: "rgba(255, 255, 255, 0.06)",
          100: "rgba(255, 255, 255, 0.1)",
          200: "rgba(255, 255, 255, 0.2)",
          300: "rgba(255, 255, 255, 0.3)",
          400: "rgba(255, 255, 255, 0.4)",
          500: "rgba(255, 255, 255, 0.5)",
          600: "rgba(255, 255, 255, 0.6)",
          800: "rgba(255, 255, 255, 0.8)",
          900: "rgba(255, 255, 255, 0.9)",
          1000: "#ffffff",
        },
        qooWhite: {
          // figma
          1: "#B7B7B7",
          2: "#CCCCCC",
          3: "#DBDBDB",
          4: "#E5E5E5",
          5: "#F2F2F2",
          6: "#F6F6F6",
          7: "#F9F9F9",
          8: "#FCFCFC",
        },
        qooBlack: {
          // figma
          1: "#0D0D0D",
          2: "#141414",
          3: "#1F1F1F",
          4: "#303030",
          5: "#3D3D3D",
          6: "#7A7A7A",
          7: "#B7B7B7",
          8: "#F2F2F2",
        },
        mainBlack: {
          30: "rgba(237, 237, 237)",
          40: "#F6F6F6",
          50: "rgba(233, 233, 233)",
          60: "rgb(240, 240, 240)",
          100: "rgba(0, 0, 0, 0.1)",
          300: "rgba(0, 0, 0, 0.3)",
          400: "rgba(0, 0, 0, 0.4)",
          500: "rgba(0, 0, 0, 0.5)",
          600: "rgba(0, 0, 0, 0.6)",
          900: "rgba(0, 0, 0, 0.9)",
          1000: "#000000",
        },
        primary: {
          // figma
          100: "#F0F5F4",
          200: "#D1E2DF", // p7 figma
          300: "#B3CDC9", // figma
          400: "#2460E6",
          500: "rgba(36, 96, 230, 0.5)",
          600: "rgba(36, 96, 230, 0.6)",
          900: "rgba(36, 96, 230, 0.9)",
          1000: "#2460E6", // primary
          // 800: "#1A4BB2"
        },
        secondary: {
          // figma
          s1: "#071322",
          s2: "#0A1A2F",
          s3: "#0D213C",
          s4: "#506CAC",
          s5: "#455A75",
          s6: "#7C8CA2",
          s7: "#B3BECF",
          s8: "#EAF1FB",
          1000: "#506CAC", // secondary
          // 800: "#0D213C"
        },
        stone: {
          40: "rgba(30, 30, 30, 0.04)",
          60: "rgba(30, 30, 30, 0.06)",
          100: "rgba(30, 30, 30, 0.1)",
          200: "rgba(30, 30, 30, 0.2)",
          300: "rgba(30, 30, 30, 0.3)",
          400: "rgba(30, 30, 30, 0.4)",
          500: "rgba(30, 30, 30, 0.5)",
          600: "rgba(30, 30, 30, 0.6)",
          800: "rgba(30, 30, 30, 0.8)",
          900: "rgba(30, 30, 30, 0.9)",
          1000: "rgb(30, 30, 30)",
        },
        danger: {
          1000: "#DC2626",
          800: "#B91C1C"
        },
        success: {
          1000: "#16A34A",
          800: "#15803D"
        },
      },
      boxShadow: {
        my: "0px 0px 0px 2px",
      },
      keyframes: {
        fillwhite: {
          from: { fill: "transparent" },
          to: { fill: "white" },
        },
        filldark: {
          from: { fill: "transparent" },
          to: { fill: "#2a2a2aff" },
        },
        spin: {
          from: { transform: "rotate(0deg)" },
          to: { transform: "rotate(360deg)" },
        },
        runner: {
          from: { transform: "translateX(25%)" },
          to: { transform: "translateX(-25%)" },
        },
      },
      transitionProperty: {
        "bg-img": "background-image",
        "bg-color": "background-color",
        fill: "fill",
      },
      transitionTimingFunction: {
        smooth: "cubic-bezier(0.65, 0, 0.076, 1)",
      },
    },
  },
  plugins: [],
};
